/*eslint-disable */
import type { VariantProps } from "class-variance-authority"
import { cva } from "class-variance-authority"

import type { MinimalToken } from "@/domains/core"
import { cn, getImageAltText, getImageUrl, getUnknownToken } from "@/domains/library"

const variants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-0",
  {
    variants: {
      square: {
        default: "border-transparent bg-primary text-t100 hover:bg-primary/80",
      },
    },
    defaultVariants: {
      square: "default",
    },
  },
)

export interface TokenIconProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof variants> {}

export const TokenIcon = ({
  token,
  className,
  square,
  calledFrom,
}: {
  token: MinimalToken
  square: number
  calledFrom: string
  className?: string
}) => {
  const widthHeight = square ?? 32

  return (
    <img
      className={cn("aspect-square", className)}
      src={getImageUrl(token)}
      width={widthHeight}
      height={widthHeight}
      alt={getImageAltText(token)}
      onError={(error) => {
        if (error) {
          // @ts-ignore
          error.target.onerror = null
          // @ts-ignore
          error.target.src = getUnknownToken()
        }
      }}
    />
  )
}
